import React from 'react';

// helpers
import {formatCurrency} from '../../../../../../shared/helpers';
import {useTranslation} from 'react-i18next';

// components
import {
  CardBorder,
  LabelContentHorizontal,
} from '../../../../../../shared/components';
import {Button} from '@mui/joy';

// styles
import {CardLoanRequestWrapper} from './CardLoanRequest-styles';
import {TextColors, TextDefault} from '../../../../../../shared/styles';

// types
import {GetLoanRequest} from '../../../../../../shared/services/ApiService/types';

type Props = {
  loanRequest: GetLoanRequest;
};

const CardLoanRequest = ({loanRequest}: Props) => {
  const {t} = useTranslation();

  /**
   * Open a new tab with the given URL
   * @param url
   */
  const goToPage = (url: string) => () => {
    window.open(url, '_blank');
  };

  return (
    <CardBorder variant="white">
      <CardLoanRequestWrapper>
        <LabelContentHorizontal
          label={t('global_status')}
          content={loanRequest.status}
        />
        <LabelContentHorizontal
          label={t('loan_amountRequested')}
          content={formatCurrency(loanRequest.amount ?? 0)}
        />
        {loanRequest.ibvUrl && (
          <Button
            size="lg"
            variant="outlined"
            onClick={goToPage(loanRequest.ibvUrl)}>
            <TextDefault bold="bold" color={TextColors.brand}>
              {t('instant_banking_verification')}
            </TextDefault>
          </Button>
        )}
        {loanRequest.contractUrl && (
          <Button
            size="lg"
            variant="outlined"
            onClick={goToPage(loanRequest.contractUrl)}>
            <TextDefault bold="bold" color={TextColors.brand}>
              {t('contract')}
            </TextDefault>
          </Button>
        )}
      </CardLoanRequestWrapper>
    </CardBorder>
  );
};

export default CardLoanRequest;
